import user from '@/API/services/user';
import miniToastr from 'mini-toastr';
import router from '@/router'

const getDefaultState = () => {
  return {
    users: [],
    clients: [],
  }
}
const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_DATA: (state, payload) => {
    if (payload.users) { state.users = payload.users.data; }
    if (payload.clients && payload.clients.data) { state.clients = ['*', ...payload.clients.data.map(client => client.name)]; state.clientsDetails = payload.clients.data }
  },
  SAVE_USER: (state, payload) => {
    state.saveResponse = payload.data;
  },
};

const actions = {
  resetUsersState: ({ commit }) => {
    commit('RESET_STATE');
  },
  removeUser: async ({ commit, dispatch }, payload) => {
    dispatch('togglePreloader', true);
    try {
      await user.removeUser(payload);
      miniToastr.success(`You have successfully removed ${payload.email} from the organisation!`, ' ');
    } catch (err) {
      console.log(commit, err)
    } finally {
      dispatch('togglePreloader', false);
    }
  },
  inviteUser: async ({ commit, dispatch }, payload) => {
    dispatch('togglePreloader', true);
    try {
      await user.inviteUser(payload);
      miniToastr.success(`You have successfully invited ${payload.email}!`, ' ');
    } catch (err) {
      console.log(commit, err)
    } finally {
      dispatch('togglePreloader', false);
    }
  },
  saveUser: async ({ commit, dispatch }, payload) => {
    dispatch('togglePreloader', true);

    try {
      const response = await user.saveUser(payload);
      commit('SAVE_USER', response);
      miniToastr.success('You have saved user!', ' ');
      router.push('/users');
    } catch (err) {
      console.log(err)
      miniToastr.error("You have not saved user!", ' ');
    } finally {
      dispatch('togglePreloader', false);
    }
  },
  fetchUsers: async ({ commit }, payload) => {
    try {
      const users = await user.fetchUsers(payload);
      if(users && users.data && users.data.length) {
        commit('SET_DATA', { users });
      }
    } catch (err) {
      console.log(err);
    }
  },
  setRole: async (_, payload) => {
    await user.setRole(payload);
  },
};

export default {
  state,
  mutations,
  actions,
};
